import './helpers/safari.js';

// Cart
import './cart/cart';

// Sections
import './sections/custom-accordion.js';
import './sections/embla-component.js';

document.addEventListener('DOMContentLoaded', function () {
  console.log('theme.js ready');
});
